import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import _ from "lodash";
import { titleCase } from "@shared/utils";

const Seo = ({ title, description, isHomePage, data }) => {
  const schemaOrg = {
    "@context": "https://schema.org",
    "@type": "SportsTeam",
    name: "Calgary Diamondbacks",
    sport: "Baseball",
    url: "https://calgarydiamondbacks.com/",
    logo: "https://calgarydiamondbacks.com/img/logo.png",
    image: "https://calgarydiamondbacks.com/img/logo.png",
    description:
      "Unleash Your Baseball Dreams - Explore Calgary Diamondbacks' Legacy, Facilities & Coaching. Join Us Today for Premier Youth & Collegiate Baseball Programs. Excellence in Baseball Since 1990s.",
    address: {
      "@type": "PostalAddress",
      streetAddress: "1401 25 Ave NE, Calgary, AB T2E 7L6",
      addressLocality: "Calgary",
      addressRegion: "Alberta",
      postalCode: "T2E 7L6",
      addressCountry: "Canada",
    },
    location: {
      "@type": "Place",
      geo: {
        "@type": "GeoCoordinates",
        latitude: "51.07493370168946",
        longitude: "-114.02367218247473",
      },
      hasMap:
        "https://www.google.com/maps?q=51.07493370168946,-114.02367218247473",
    },
    // award: "WCBL CHAMPIONS '04 '07 '08 '09 '19 '22 '23 '24",
    email: "mailto:info@calgarydiamondbacks.com",
  };

  const metaDescription = description || data?.site?.siteMetadata?.description;
  const titleSuffix = data?.site?.siteMetadata?.title;

  useEffect(() => {
    // Load google tag manager script
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "G-KP116M915X");
    }
  }, []);

  return (
    <Helmet
      titleTemplate={titleSuffix && !isHomePage ? `%s | ${titleSuffix}` : null}
    >
      <html lang="en" />
      <meta charset="UTF-8" />
      <title>{title}</title>
      <meta name="description" content={metaDescription} />
      <meta
        property="og:title"
        content={
          titleSuffix && !isHomePage
            ? `${titleCase(title)} | ${titleSuffix}`
            : title
        }
      />
      <meta property="og:url" content="https://calgarydiamondbacks.com/" />
      <meta property="og:type" content="website" />
      <meta
        property="og:image"
        content="https://calgarydiamondbacks.com/splash_screen.png"
      />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:site_name" content="Diamondbacks" />

      {/* Favicon Stuff */}
      <meta name="msapplication-TileColor" content="#000000" />
      <meta name="theme-color" content="#000000" />
      {/* <meta
                name="google-site-verification"
                content="GoogleSiteVerificationKey"
            /> */}
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/apple-touch-icon.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicon-16x16.png"
      />
      <link rel="manifest" href="/site.webmanifest" />
      <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#000000" />
      <script type="application/ld+json">{JSON.stringify(schemaOrg)}</script>
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-KP116M915X"
      ></script>
    </Helmet>
  );
};

Seo.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default Seo;
